import { render, staticRenderFns } from "./MatchingJobs.vue?vue&type=template&id=fb752a84&scoped=true&"
import script from "./MatchingJobs.vue?vue&type=script&lang=ts&"
export * from "./MatchingJobs.vue?vue&type=script&lang=ts&"
import style0 from "./MatchingJobs.vue?vue&type=style&index=0&id=fb752a84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb752a84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDivider,VList,VSkeletonLoader})
